export default __webpack_public_path__ + "static/media/next_arrow.7c31f79d.svg";